import { createAsyncThunk } from '@reduxjs/toolkit';
import api from './api';
import { constURL } from './enum.services';
import axios from 'axios';

export const getOperators = createAsyncThunk(
  'filters/getOperators',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(constURL.OPERATORS);
      return response.data.listUsers;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return rejectWithValue(error.response.status);
      }
      throw error;
    }
  }
);

export const getSubOperators = createAsyncThunk(
  'filters/getSubOperators',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(constURL.OPERATORS);
      return response.data.listSubUsers;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return rejectWithValue(error.response.status);
      }
      throw error;
    }
  }
);
